import { SKINS } from "~/contexts/SkinContext/skinConstants.ts";
import type { DebugSearch } from "~/features/game/components/ScoreTakingDebugView/scoreTakingDebugTypes.ts";
import { parseDebugSessionSearch } from "~/features/gameSession/debugSessionGenerator/debugSessionSearch.ts";

/**
 * Parses the search params of the debug routes.
 *
 * Rule: this file imports types, other search parsers, and constant files with no import. The route config imports
 * it outside the code-split component chunk, so any other import ships in the main bundle.
 */
export const parseDebugSearch = (search: Record<string, unknown>): DebugSearch => ({
    ...parseDebugSessionSearch(search),
    scenario: typeof search.scenario === "string" ? search.scenario : undefined,
    players: typeof search.players === "number" ? search.players : undefined,
    size: typeof search.size === "string" ? search.size : undefined,
    skin: SKINS.find((skin) => skin === search.skin),
});
